let newsletter = require('newsletter/client');
let Carousel = require('client/carousel');
let notification = require('client/notification');
let gaHitCallback = require('gaHitCallback');

import VimeoVideoPlayer from 'client/vimeoVideoPlayer';

const modalTemplate = require('./modal.pug');
const clientRender = require('client/clientRender');

newsletter.initNewsletterForm();

const LANG = require('config').lang;
const t = require('engine/i18n/t');

const videoContainer = document.querySelector('.courses-overview__video-container');
if (videoContainer) initPlayer(videoContainer);

function initPlayer(elem) {
  const video = elem.querySelector('.courses-overview__video[data-video-id]');
  const videoId = video.getAttribute('data-video-id');

  video.addEventListener('click', (e) => {
    e.preventDefault();
    elem.classList.add('courses-overview__video-container_playing');
    const player = new VimeoVideoPlayer({
      videoId,
      onClose: function() {
        elem.classList.remove('courses-overview__video-container_playing');
      }
    });

    player.openVideo();
  });
}

t.i18n.add('courses', require('../../locales/' + LANG + '.yml'));

const coursesFeedback = document.querySelector('.courses-feedback-inline');

if (coursesFeedback) new Carousel({
  elem: coursesFeedback
});

{
  let courseSignupRef1 = document.getElementById('course-signup-ref-1');
  let courseSignupRef2 = document.getElementById('course-signup-ref-2');

  if (courseSignupRef1 && courseSignupRef2) {
    let initialBottom = courseSignupRef1.getBoundingClientRect().bottom + window.pageYOffset;
    // console.log(initialBottom);
    window.addEventListener('scroll', function toggleSignupButton() {
      if (courseSignupRef1.getBoundingClientRect().bottom < 0) { // top button scrolled out
        courseSignupRef2.style.display = '';
      } else if (window.pageYOffset < initialBottom) { // scrolled up till the old top button locationn
        courseSignupRef2.style.display = 'none';
      }
    });
  }
}

{
  window.addEventListener('scroll', showActiveCourseNav, {passive: true});
  //window.addEventListener('scroll', stickToRightCourseNav, {passive: true});

  function showActiveCourseNav() {
    let newActive = document.querySelector('.course-nav__bar-link');

    for(let link of document.querySelectorAll('.course-nav__bar-link')) {
      let id = link.getAttribute('href').slice(1);
      let a = document.getElementById(id);

      if (!a) continue; // incorrect document!

      if (a.getBoundingClientRect().top < 160) {
        newActive = link;
      } else {
        break;
      }
    }

    let oldActive = document.querySelector('.course-nav__bar-link_active');
    if (oldActive != newActive) {
      if (oldActive) {
        oldActive.classList.remove('course-nav__bar-link_active');
      }
      // console.log(newActive);
      newActive.classList.add('course-nav__bar-link_active');
    }

  }
/*
  function stickToRightCourseNav() {
    let nav = document.querySelector('.course-nav');
    if (nav.style.position == 'fixed' && )
  }*/
}

{
  let subscribeLink = document.querySelector('[data-course-subscribe-open]');
  if (subscribeLink) {
    subscribeLink.onclick = () => {
      let form = document.querySelectorAll('[data-newsletter-subscribe-form]');
      form = form[form.length - 1];
      form.style.display = form.style.display == 'none' ? '' : 'none';
    }
  }
}


{
  function openCourseCarousel(imageNumber) {
    let modal = new Modal();
    modal.elem.classList.add('course-modal');

    let dataElem = document.querySelector('[data-course-carousel]');
    let options = JSON.parse(dataElem.dataset.courseCarousel);

    modal.setContent(clientRender(modalTemplate, options));

    let carousel = new Carousel({
      elem: modal.elem,
    });

    carousel.setPosition(imageNumber - 1);

    function keydown(event) {
      if (event.code == 'ArrowLeft') {
        carousel.prev();
      }
      if (event.code == 'ArrowRight') {
        carousel.next();
      }
    }


    document.addEventListener('keydown', keydown);
    modal.elem.addEventListener('modal-remove', () => document.removeEventListener('keydown', keydown));
  }

  document.body.addEventListener('click', event => {
    let opener = event.target.closest('[data-course-carousel-open-image]');
    if (opener) {
      openCourseCarousel(+opener.dataset.courseCarouselOpenImage);
    }
  });

}

/*
let coursesSignupButton = document.querySelector('[data-course-signup-button]');

if (coursesSignupButton) {

  coursesSignupButton.addEventListener('click', function() {

    let form = coursesSignupButton.form;
    let slug = form.elements.slug.value; // hidden
    if (!slug) {
      // radio
      let checkedRadio = Array.from(form.slug).filter(e => e.checked)[0];
      if (!checkedRadio) {
        new notification.Error(t('courses.signup.choose_group'));
        return;
      }
      slug = checkedRadio.value;
    }

    window.location.href = '/courses/groups/' + slug + '/signup';

  });
}
*/
